// Hooks / Node modules / Styles
import { Button } from "elseware-ui";
import { useNavigate } from "react-router-dom";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components
import ComponentContainer from "../ComponentContainer";
import ProjectCardGroup from "./com/ProjectCardGroup";

// Data / Images / Icons

function Projects() {
  const navigate = useNavigate();

  return (
    <ComponentContainer
      title="Projects"
      subtitle="My latest works"
      description="These projects showcase my skills and experience through real-world examples of my work. Each project is briefly described with links to the code repositories and live demos. These projects reflect my ability to solve complex problems, work with different technologies, and manage projects effectively."
    >
      <ProjectCardGroup />

      <div className="w-full flex flex-row items-center justify-center mt-10">
        <Button
          variant="success"
          text="See all Projects"
          shape="softRoundedSquare"
          onClick={() => navigate("/projects/software")}
        />
      </div>
    </ComponentContainer>
  );
}

export default Projects;
